import React, { useContext } from 'react';
import { ComponentContext, SelectionMarkerType } from '../../contexts';
import { COLORS } from '../../constants';
import { GenericEllipse } from '../../generic/ellipse';
import { LabelWithIcon } from '../../generic/label-with-icon';
export const Ellipse = ({ definition }) => {
    const { width, height, icon, text, strokeWidth } = definition;
    const { SelectionMarker } = useContext(ComponentContext);
    return (React.createElement("svg", { style: { pointerEvents: 'all' } },
        React.createElement(GenericEllipse, { width: width, height: height, strokeWidth: strokeWidth, strokeColor: definition.strokeColor || COLORS.DEFAULT_STROKE, fill: definition.fillColor || COLORS.FILL, notBounding: true }),
        text || icon ? React.createElement(LabelWithIcon, { definition: definition }) : null,
        React.createElement(SelectionMarker, { width: width, height: height, type: SelectionMarkerType.ROUND })));
};
//# sourceMappingURL=ellipse.js.map